import { render, staticRenderFns } from "./loseReason.vue?vue&type=template&id=3a388180&scoped=true"
import script from "./loseReason.vue?vue&type=script&lang=js"
export * from "./loseReason.vue?vue&type=script&lang=js"
import style0 from "./loseReason.vue?vue&type=style&index=0&id=3a388180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a388180",
  null
  
)

export default component.exports